import type { IconSvgObject } from './types';

const PieChart09Icon: IconSvgObject = [
  ["path", { d: "M16.5557 4.6853C14.9112 3.58649 12.9778 3 11 3V13L18.1414 20C19.5015 18.6124 20.4285 16.858 20.8079 14.9509C21.1937 13.0111 20.9957 11.0004 20.2388 9.17317C19.4819 7.3459 18.2002 5.78412 16.5557 4.6853Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 20.4185C13.0736 20.7935 12.0609 21 11 21C6.58172 21 3 17.4183 3 13C3 9.56306 5.16736 6.63232 8.20988 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PieChart09Icon;
